<template>
    <div style="padding-top: 20px;">
        <p>
            List of Cancelled Approvals{{ displayDate.frDate ? ` from ${displayDate.frDate} to ` : '' }}{{ displayDate.toDate ? displayDate.toDate : '' }}
            <v-btn class="float-right" @click="$emit('closeListOfCancelledApprovals')">
                <v-icon>{{ mdiArrowLeft }}</v-icon> go back
            </v-btn>
        </p>
        <v-form
            ref="form"
            @submit.prevent="handleFetchCancelledApproval"
        >
            <v-text-field
                v-model="dateRange.FR_DATE"
                label="Start Date"
                type="date"
                style="width: 180px; display: inline-block; margin-right: 5px;"
                :rules="[v=>!!v||'This field is required']"
                outlined
                dense
            />
            <v-text-field
                v-model="dateRange.TO_DATE"
                label="End Date"
                type="date"
                style="width: 180px; display: inline-block; margin-right: 5px;"
                :rules="[v=>!!v||'This field is required']"
                outlined
                dense
            />
            <v-btn
                type="submit"
                color="teal darken-1 white--text"
            >
                refresh
            </v-btn>
        </v-form>
        <v-card>
            <v-data-table
                :items="listCancelledApprovalData ? listCancelledApprovalData.data : []"
                :headers="headers"
                :loading="loading ? 'teal darken-1' : false"
                sort-by="CANCEL_TIMESTAMP"
                :sort-desc="true"
                style="margin-top: 30px;"
            >
                <template #[`item.OPAN_N`]="{ item }">
                    <span style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">{{ item.OPAN_N }}</span>
                </template>
                <template #[`item.MEMB_N`]="{ item }">
                    <span style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">{{ item.MEMB_N }}</span>
                </template>
                <template #[`item.LAST_M`]="{ item }">
                    <span style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">{{ item.LAST_M }}</span>
                </template>
                <template #[`item.hosp_name`]="{ item }">
                    <span style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">{{ item.hosp_name }}</span>
                </template>
                <template #[`item.CANCEL_TIMESTAMP`]="{ item }">
                    <span style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">{{ formatCancelledTimestamp(item.CANCEL_TIMESTAMP) }}</span>
                </template>
                <template #[`item.INTREM`]="{ item }">
                    <v-btn style="text-transform: none;" @click="handleShowInternalRemarks(item)">
                        <v-icon>{{ mdiEye }}</v-icon>&nbsp;Show Remarks
                    </v-btn>
                </template>
                <template #[`item.HISTORY`]="{ item }">
                    <v-btn style="text-transform: none;" @click="handleShowHistory(item)">
                        <v-icon>{{ mdiEye }}</v-icon>&nbsp;Show History
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog
            :key="history.approvalNumber"
            v-model="showHistory"
            width="600"
        >
            <v-card>
                <v-card-title style="background-color: #009688; color: white;">
                    History: {{ history.approvalNumber }}
                    <v-spacer />
                    <v-tooltip top>
                        <template #activator="{ on, attrs }">
                            <v-btn 
                                icon 
                                color="white"
                                v-bind="attrs" 
                                @click="showHistory=false"
                                v-on="on"
                            >
                                <v-icon>{{ mdiClose }}</v-icon>
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </v-card-title>
                <v-card-text style="padding-top: 20px;">
                    <v-textarea
                        v-model="history.value"
                        label="History"
                        outlined
                        color="teal darken-1"
                        readonly
                    />
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog
            :key="internalRemarks.approvalNumber"
            v-model="showRemarks"
            width="600"
        >
            <v-card>
                <v-card-title style="background-color: #009688; color: white;">
                    Internal Remarks: {{ internalRemarks.approvalNumber }}
                    <v-spacer />
                    <v-tooltip top>
                        <template #activator="{ on, attrs }">
                            <v-btn 
                                icon 
                                color="white"
                                v-bind="attrs" 
                                @click="showRemarks=false"
                                v-on="on"
                            >
                                <v-icon>{{ mdiClose }}</v-icon>
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </v-card-title>
                <v-card-text style="padding-top: 20px;">
                    <v-textarea
                        v-model="internalRemarks.value"
                        label="Internal Remarks"
                        outlined
                        color="teal darken-1"
                        readonly
                    />
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { moment } from '../../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiEye,
    mdiArrowLeft
} from '@mdi/js'
export default {
    props: ['showCancelled'],
    data: ()=>({
        mdiClose,
        mdiEye,
        mdiArrowLeft,
        internalRemarks: { show: false, value: null, approvalNumber: null  },
        history: { show: false, value: null, approvalNumber: null  },
        loading: false,
        displayDate: { frDate: null, toDate: null },
        dateRange: {
            FR_DATE: null,
            TO_DATE: null
        },
        headers: [
            { text: 'Approval Number', value: 'OPAN_N' },
            { text: 'Member Number', value: 'MEMB_N' },
            { text: 'Name', value: 'LAST_M' },
            { text: 'Account Number', value: 'ACCT_N' },
            { text: 'Account Name', value: 'ACCT_M' },
            { text: 'Hospital Name', value: 'hosp_name' },
            { text: 'Cancel Timestamp', value: 'CANCEL_TIMESTAMP' },
            { text: 'Internal Remarks', value: 'INTREM' },
            { text: 'Member Number', value: 'HISTORY' }
        ]
    }),
    computed: {
        ...mapGetters(['listCancelledApprovalData']),
        showHistory: {
            get() {
                return this.history.show
            },
            set() {
                this.closeHistory()
            }
        },
        showRemarks: {
            get() {
                return this.internalRemarks.show
            },
            set() {
                this.closeRemarks()
            }
        }
    },
    watch: {
        showCancelled(newVal) {
            if (newVal) {
                this.loading = true
                const dateToday = moment()
                this.dateRange.FR_DATE = moment(dateToday).subtract(3, 'days').format('YYYY-MM-DD')
                this.dateRange.TO_DATE = moment(dateToday).format('YYYY-MM-DD')
                this.displayDate.frDate = moment(this.dateRange.FR_DATE).format('MMMM D, YYYY')
                this.displayDate.toDate = moment(this.dateRange.TO_DATE).format('MMMM D, YYYY')
                this.listCancelledApproval(this.dateRange)
            } else {
                this.$store.commit('LIST_CANCELLED_APPROVAL', [])
            }
        },
        listCancelledApprovalData(newVal) {
            this.loading = false
            console.log('listCancelledApprovalData newVal: ', newVal)
        }
    },
    mounted() {
        // this.getCsrfToken()
    },
    methods: {
        ...mapActions(['listCancelledApproval', 'getCsrfToken']),
        handleShowHistory(item) {
            this.history = {
                approvalNumber: item.OPAN_N,
                value: item.HISTORY,
                show: true
            }
        },
        closeHistory() {
            this.history = {
                approvalNumber: null,
                value: null,
                show: false
            }
        },
        closeRemarks() {
            this.internalRemarks = {
                approvalNumber: null,
                value: null,
                show: false
            }
        },
        handleShowInternalRemarks(item) {
            this.internalRemarks = {
                approvalNumber: item.OPAN_N,
                value: item.INTREM,
                show: true
            }
        },
        formatCancelledTimestamp(date) {
            return moment(date).format('MMMM D, YYYY HH:mm:ss')
        },
        handleFetchCancelledApproval() {
            this.listCancelledApproval(this.dateRange)
            this.displayDate.frDate = moment(this.dateRange.FR_DATE).format('MMMM D, YYYY')
            this.displayDate.toDate = moment(this.dateRange.TO_DATE).format('MMMM D, YYYY')
        }
    }
}
</script>
